import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import debounce from 'debounce';
import { Alert, Form, Input, Modal, Tag } from 'antd';

import { addNewBrands, addNewBrandsAsync } from './actions';

import { API_ENDPOINT } from '../../index';

const defaultState = {
	validateStatus: '', 
	inputMsg:'Enter a brand name.'	
}

class AddBrandModal extends React.Component{

	props: {
		modalIsOpen: boolean,
		addNewBrands( brands:string[] ): void,
		onCloseModal():void
	}

	render(){

		const { getFieldDecorator } = this.props.form;
		const { modalIsOpen } = this.props;

		const { loading, validateStatus, inputMsg } = this.state;

		return (
			<Modal
				title="Add Brands"
				okText={"Save"}
				confirmLoading={loading}
				onOk={this.handleOnClickOK}
				onCancel={this.handleOnCancel}

				visible={modalIsOpen}>
				
				{
					modalIsOpen?
					[
						<Alert
							message="Mass Upload Instruction"
							description="Press [ENTER] to add more brands."
							type="info"
							showIcon
							/>,	
		
						<Form>
							
							<Form.Item
								hasFeedback
								validateStatus={validateStatus}
								help={inputMsg}
								label="Brand Names">
		
								{this.state.brands.map(
									(brand, i) => <Tag 
										key={i}
										closable onClose={(e) => this.removeBrand(e, i)}>{brand}</Tag>
								)}
		
								{getFieldDecorator('brand', {
									rules: [
										{validator: this.checkIfBrandAlreadyExist }
									]
								})(
									<Input 
										onKeyPress={this.handleKeyPress}
										onChange={this.handleOnChange}
										placeholder="3M"/>
								)}
		
							</Form.Item>
						</Form>,
		
						
						this.state.searchedBrands.map(
							(_brand, i) => <p key={i}>{_brand.name}</p>
						)
					]:
					null
				}

			</Modal>
		)
	}

	state = {
		...defaultState,
		brands:[],
		loading:false,
		searchedBrands:[]
	};

	constructor(props){
		super(props);

		this.handleSearch = debounce(this.handleSearch, 350);
	}

	checkCurrentBrands = (brands: string[], brand: string) => {

		console.log(brands, brand);

		const matchingBrands = brands.filter( _brand => _brand.trim().toLowerCase() === brand.trim().toLowerCase());

		console.log(matchingBrands);
		
		if(matchingBrands.length > 0){
			return true;
		}

		return false;

	}
 
	checkIfBrandAlreadyExist = (rule, value, callback) => {
		console.log('checkIfBrandAlreadyExist', 'checkIfBrandAlreadyExist');
		if(value){

			const { brands } = this.state;
			
			if(this.checkCurrentBrands(brands, value)){

				this.showError(1);

				callback("This brand already exist! Please do not add the same brands twice!");

			} else {
				this.setState({
					validateStatus: 'validating',
					inputMsg: 'Checking the database if brands already exist...',
					searchedBrands: [{ name: "Loading..."}]
				});
				
				this.handleSearch(value, callback);
			}

		} else {

			this.setState({...defaultState});

			callback();
		}
	}

	handleKeyPress = (e) => {

		if(e.charCode === 13){

			const { setFieldsValue, validateFields } = this.props.form;

			validateFields(
				(err, val) => {
					if (!err) {

						const { brand } = val;

						if( !brand ){

							this.showRequiredMsg();

						} else {

							setFieldsValue({ brand: '' });
							
							this.setState({
								brands: [
									...this.state.brands,
									brand
								]
							});

						}
						
					} else {
						this.showError(2);	
					}
				},
			);

		}

	}

	handleOnCancel = () => {

		this.setState({
			...defaultState,
			brands: [],

		});

		this.props.onCloseModal();
	}

	handleOnClickOK = (e) => {
		this.setState({loading:true});

		this.props.form.validateFields(
      (err, val) => {
        if (!err) {

					const { brand } = val;
					let { brands } = this.state;


					if(this.checkCurrentBrands(brands, brand)){
						return this.showError(6);
					}

					if(brand){
						brands = [...brands, brand];
					}

					if(brands.length > 0){
						
						addNewBrandsAsync(brands)
							.then( res => {
								this.setState({loading:false});
								this.props.dispatch(addNewBrands(res.data.brands));
								this.handleOnCancel();
							})
							.catch( err => {
								this.setState({loading:false});
							});
					} else {
						this.showRequiredMsg();
					}
					
        } else {
					this.showError(3);
				}
      },
    );
	}

	handleSearch = (brand, cb) => {
		
		axios({
			withCredentials: true,
			url: `${API_ENDPOINT}/api/brands/search/${brand.trim()}`
		})
			.then( res => {
				
				const { brands } = this.state;
				console.log(brand.trim().toLowerCase());

				this.setState({
					searchedBrands: res.data.brands
				})

				console.log(brands, brand);

				if (this.checkCurrentBrands(brands, brand)){
					this.showError(4);

					cb("This brand already exist! Please do not add the same brands twice!");
				} else if(
					res.data.brands.filter( _brand => {
						return _brand.lowerCaseName === brand.trim().toLowerCase() 
					}).length > 0
				){

					this.showError(5);
					cb("This brand already exist! Please do not add the same brands twice!");

				} else {

					this.showSuccess();

					cb();

				}
			})
	};
	
	removeBrand = (e, i) => {
		e.preventDefault();

		this.setState({
			brands: [
				...this.state.brands.filter( (item, index) => index !== i)
			]
		})
	}

	showError = (int) => {
		this.setState({
			validateStatus: 'error',
			inputMsg: 'This brand already exist! Please do not add the same brands twice!'
		});
	}

	showRequiredMsg = () => {
		this.setState({
			validateStatus: 'error',
			inputMsg: 'Brand name is required!'
		});
	}

	showSuccess = () => {
		this.setState({
			validateStatus: 'success',
			inputMsg: 'Click enter to add a new brand.'
		});
	}

}

export default connect()(Form.create()(AddBrandModal));


// WEBPACK FOOTER //
// ./src/components/brands/add-brand-modal.js